const capitalMarketsCareers = [

    {
        id: 11,
        slug: "capital-markets-junior-research-analyst",
        title: "Junior Research Analyst (JRA)",
        department: "Capital Markets Research",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Collect company and industry data from public sources",
                "Support preparation of market research reports",
                "Assist in company profiles and investment summaries",
                "Maintain research databases and data sheets",
                "Support analysts in preparing presentations and reports"
            ],
            skills: [
                "Basic research and analytical skills",
                "Excel and PowerPoint fundamentals",
                "Attention to detail",
                "Ability to work with large datasets"
            ],
            experience: ["Fresher"],
            education: ["Bachelor’s degree in Finance, Economics, Business, or Commerce"]
        }
    },

    {
        id: 12,
        slug: "research-analyst",
        title: "Research Analyst (RA)",
        department: "Capital Markets Research",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Conduct company and industry research",
                "Prepare research summaries and market reports",
                "Assist in financial modeling and valuation work",
                "Support investment screening and deal sourcing",
                "Prepare competitor and market landscape analysis"
            ],
            skills: [
                "Financial analysis basics",
                "Excel and PowerPoint proficiency",
                "Business research capability",
                "Analytical thinking"
            ],
            experience: ["0–1 years"],
            education: [
                "Bachelor’s degree in Finance, Economics, Business, or Commerce",
                "CFA Level I or MBA Finance preferred"
            ]
        }
    },

    {
        id: 13,
        slug: "senior-research-analyst",
        title: "Senior Research Analyst (SRA)",
        department: "Capital Markets Research",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Lead industry and market research projects",
                "Build financial models and valuation analysis",
                "Prepare investment notes and research reports",
                "Analyze industry trends and growth opportunities",
                "Support private equity and investment banking research"
            ],
            skills: [
                "Financial modeling and valuation",
                "Industry research and analysis",
                "Data interpretation",
                "Strong analytical skills"
            ],
            experience: ["1–3 years"],
            education: [
                "Bachelor’s or Master’s degree in Finance, Economics, or Business",
                "CFA / MBA Finance preferred"
            ]
        }
    },

    {
        id: 14,
        slug: "associate",
        title: "Associate",
        department: "Capital Markets Research",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Manage research workstreams for client projects",
                "Prepare detailed investment analysis and reports",
                "Build financial models and market assessments",
                "Support due diligence and transaction research",
                "Coordinate work between analysts and senior team members"
            ],
            skills: [
                "Financial modeling and valuation",
                "Investment research",
                "Structured problem solving",
                "Communication and coordination"
            ],
            experience: ["3+ years"],
            education: [
                "Bachelor’s or Master’s degree in Finance, Economics, or Business",
                "CFA / MBA Finance preferred"
            ]
        }
    },

    {
        id: 15,
        slug: "senior-associate",
        title: "Senior Associate",
        department: "Capital Markets Research",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Lead research execution for client engagements",
                "Review financial models and research reports",
                "Support transaction analysis and deal evaluation",
                "Prepare investment presentations and memos",
                "Mentor junior analysts and associates"
            ],
            skills: [
                "Advanced financial analysis",
                "Valuation and transaction research",
                "Research leadership",
                "Strong analytical thinking"
            ],
            experience: ["5+ years"],
            education: [
                "Bachelor’s or Master’s degree in Finance, Economics, or Business",
                "CFA / MBA Finance preferred"
            ]
        }
    }
];

export default capitalMarketsCareers;
